import { handleApiCalls } from './axiosInstance';

const normalizePromptsResponse = payload => {
  const normalizedPayload =
    Array.isArray(payload) || Array.isArray(payload?.documents)
      ? payload
      : payload?.data || payload;

  if (Array.isArray(normalizedPayload)) {
    return {
      documents: normalizedPayload,
      totalCount: normalizedPayload.length,
    };
  }

  const documents = Array.isArray(normalizedPayload?.documents) ? normalizedPayload.documents : [];

  return {
    documents,
    totalCount:
      typeof normalizedPayload?.totalCount === 'number'
        ? normalizedPayload.totalCount
        : typeof normalizedPayload?.count === 'number'
        ? normalizedPayload.count
        : documents.length,
  };
};

const PromptsAPI = Object.freeze({
  fetchPrompts: async () => {
    const response = await handleApiCalls('get', `${process.env.REACT_APP_HOST_API}prompts`);

    return normalizePromptsResponse(response.data);
  },

  fetchPrompt: async promptId => {
    const response = await handleApiCalls(
      'get',
      `${process.env.REACT_APP_HOST_API}prompts/${promptId}`,
    );

    return response.data?.data || response.data;
  },

  createPrompt: async data => {
    const response = await handleApiCalls('post', `${process.env.REACT_APP_HOST_API}prompts`, data);

    return response.data?.data || response.data;
  },

  updatePrompt: async (promptId, data) => {
    const response = await handleApiCalls(
      'put',
      `${process.env.REACT_APP_HOST_API}prompts/${promptId}`,
      data,
    );

    return response.data?.data || response.data;
  },

  deletePrompt: async promptId => {
    const response = await handleApiCalls(
      'delete',
      `${process.env.REACT_APP_HOST_API}prompts/${promptId}`,
    );

    return response.data;
  },
});

export default PromptsAPI;
